import styled from "styled-components/macro";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const ServicesContainer = styled.div`
  /* height: 800px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  margin: auto;
  max-width: 1200px;
  /* background: aqua; */
  @media screen and (max-width: 1370px) {
    padding: 0 1.2rem;
  }
`;

export const AbMainBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 1rem 0;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
  @media (max-width: 769px) {
    flex-direction: column;
  }
`;

export const AbLeftBox = styled.div`
  width: 58%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: start;
  /* align-items: ${defaultLanguage === "ar" ? "end" : "start"}; */
  padding: 3rem 0;
  @media (max-width: 769px) {
    width: 100%;
  }
`;

export const AbRightBox = styled.div`
  width: 42%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(6, auto);
  grid-gap: 15px;
  margin: auto;
  @media (max-width: 769px) {
    width: 100%;
  }
`;

export const AboutText = styled.div`
  letter-spacing: 3.2px;
  margin-bottom: 10px;
  text-transform: uppercase;
  color: #ed7d2b;
  opacity: 1;
  font-weight: 700;
  font-size: 1.75rem;
  @media (max-width: 769px) {
    font-size: 1.1rem;
  }
`;

export const AbHowText = styled.div`
  letter-spacing: 0px;
  color: #212529;
  opacity: 1;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0.8rem 0rem;
  @media (max-width: 769px) {
    font-size: 1.6rem;
  }
`;

export const MainDesc = styled.span`
  color: #ed7d2b;
`;

export const AbHowDesc = styled.div`
  /* margin-right: 3rem; */
  margin-right: ${defaultLanguage === "ar" ? "0" : "3rem"};
  /* text-align: ${defaultLanguage === "ar" ? "right" : "left"}; */
  margin-left: ${defaultLanguage === "ar" ? "3rem" : "0"};
  @media (max-width: 769px) {
    font-size: 0.9rem;
    margin-right: ${defaultLanguage === "ar" ? "0" : "3rem"};
    text-align: ${defaultLanguage === "ar" ? "right" : "left"};
    margin-left: ${defaultLanguage === "ar" ? "3rem" : "0"};
  }
  @media (max-width: 551px) {
    margin-right: 0rem;
  }
`;

export const AbImgBox = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Image1 = styled.div`
  grid-column-start: 1;
  grid-column-end: 7;
  grid-row-start: 1;
  grid-row-end: 6;
`;

export const Image2 = styled.div`
  grid-column-start: 7;
  grid-column-end: 13;
  grid-row-start: 1;
  grid-row-end: 4;
`;
export const Image3 = styled.div`
  grid-column-start: 7;
  grid-column-end: 13;
  grid-row-start: 4;
  grid-row-end: 6;
`;
export const CommonImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
`;
export const AbHalfImgBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1.5rem;
`;

export const AbHalfImg = styled.img`
  &:last-child {
    margin-top: 1.5rem;
  }
`;

export const AbPointBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

export const AbPointSingle = styled.div`
  width: 100%;
  display: flex;
  margin-top: 0.5rem;
`;

export const Abdash = styled.span`
  color: #ed7d2b;
  font-weight: 700;
  margin-right: 1rem;
`;

export const AbdashText = styled.div`
  @media (max-width: 769px) {
    font-size: 0.9rem;
  }
`;

export const EquimentBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
`;

export const BedBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  border-right: 1px solid #ed7d2b;
  align-items: center;
`;

export const BathroomBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  border-right: 1px solid #ed7d2b;
  align-items: center;
`;

export const CarBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  border-right: 1px solid #ed7d2b;
  align-items: center;
`;

export const SquareBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  align-items: center;
`;

export const BedQuantity = styled.div`
  display: flex;
  align-items: center;
`;

export const BedNumber = styled.div`
  margin-right: 0.5rem;
`;

export const BedIcon = styled.img``;

export const BedText = styled.div`
  letter-spacing: 2.56px;
  color: #4d3a3a;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  font-weight: 500;
`;

export const CheckPropertyBtn = styled.div`
  display: flex;
  align-items: left;
  @media (max-width: 769px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const ViewBtn = styled.button`
  border-radius: 2px;
  white-space: nowrap;
  padding: 0.8em 2em;
  background: #ed7d2b;
  border: #ed7d2b;
  color: #f1f1f1;
  font-size: 1rem;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  border-radius: 4px;
  margin-top: 2rem;
  font-family: "Montserrat";
  font-weight: 500;
  /* margin-bottom: 1rem; */

  @media screen and (max-width: 480px) {
    padding: 0.7em 6em;
  }
  @media screen and (max-width: 390px) {
    padding: 0.7em 4em;
    font-size: 0.8rem;
  }
`;
